// src/components/common/InfoTooltip.jsx
import React, { useState } from 'react';
import { InformationCircleIcon } from '@heroicons/react/24/outline';
import { useConfig } from '../../hooks/useConfigs';
const InfoTooltip = ({
  tooltipKey,
  title,
  description,
  children,
  fallbackDescription = '',
}) => {
  const [visible, setVisible] = useState(false);
  const { getTooltip, loading } = useConfig();

  const raw = tooltipKey
    ? getTooltip(tooltipKey, fallbackDescription || description)
    : description || fallbackDescription;

  const tooltipText   = typeof raw === 'string' ? raw : String(raw || '');
  const formattedText = tooltipText.split('\\n').join('\n');

  // Parse **bold** markers
  const parseText = (text) =>
    text.split(/(\*\*.*?\*\*)/g).map((part, i) =>
      part.startsWith('**') && part.endsWith('**')
        ? <span key={i} className="font-bold">{part.slice(2, -2)}</span>
        : part,
    );

  if (loading && !description && !fallbackDescription) {
    return children || <InformationCircleIcon className="w-4 h-4 text-grey-400" />;
  }

  return (
    <div className="relative inline-block">
      <div
        onMouseEnter={() => setVisible(true)}
        onMouseLeave={() => setVisible(false)}
        className="cursor-help"
      >
        {children || (
          <InformationCircleIcon className="w-4 h-4 text-grey-400 hover:text-brightblue-500 transition-colors" />
        )}
      </div>

      {visible && formattedText && (
        <div className="absolute z-50 top-full left-0 mt-2 w-80 max-w-[90vw] min-w-[250px] bg-darkblue-500 text-white text-xs rounded-lg shadow-lg overflow-hidden">
          <div className="px-4 py-3">
            {title && (
              <div className="font-semibold text-brightblue-300 mb-2 break-words">
                {title}
              </div>
            )}
            <div className="text-darkblue-100 leading-relaxed break-words whitespace-pre-line text-left">
              {parseText(formattedText)}
            </div>
          </div>
          {/* Arrow */}
          <div className="absolute bottom-full left-4 border-4 border-transparent border-b-darkblue-500" />
        </div>
      )}
    </div>
  );
};

export default InfoTooltip;